export const getShortText = (text: string, totalLength: number) => {
  return text.length <= totalLength
    ? text
    : text?.slice(0, totalLength - 3) + '...';
};
